<template>
    <div class="block-box">
        <div class="block-item">
            <div class="label">
                {{configData.title}}
            </div>
            <el-cascader v-model="configData.activeValue" :options="treeSelect" :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'name',
                value: 'category_id'
            }" clearable />
        </div>
    </div>
</template>

<script>
    import * as Category from '@/api/category';

    export default {
        name: "gcategory",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
        created() {
            this.getList()
        },
        data () {
            return {
                treeSelect: [
                ],
                loading: false
            }
        },
        methods: {
            // 列表
            getList() {
                this.loading = true;
                Category.tree(this.formItem).then((res) => {
                    if (res.code == 1) {
                        this.treeSelect = res.data.list
                        this.loading = false;
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
